import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Typography, useTheme } from '@qbe/ads-core';
import * as React from 'react';

import Modal from '~/components-ds/Modal';
import { useAppContent, useAppDispatch, useAppNavigate } from '~/hooks';
import { qalFormStartAction, qalTrackEngagementAction } from '~/thunks/analytics';
import { navigateAction } from '~/thunks/navigateAction';

type EditModalProps = {
  closeModal: () => void;
  editRoute: string;
};

const EditModal: React.FC<EditModalProps> = ({ closeModal, editRoute }) => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.editModal' });

  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const theme = useTheme();

  const onClose = () => {
    dispatch(
      qalTrackEngagementAction({
        eventAction: 'modal: close',
        eventLabel: 'edit warning',
        data: {},
      })
    );
  };

  return (
    <Modal
      open
      analyticsModalName="Edit Warning Modal"
      title={getTextContent('title')}
      iconProps={{
        muiIcon: InfoOutlined,
        // TODO - https://qbe-appservices.atlassian.net/browse/AD1-445
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        color: theme.color.icon.info,
      }}
      id="edit-review-modal"
      primaryBtnProps={{
        label: getTextContent('primaryAction'),
        onClick: () => {
          dispatch(qalFormStartAction());
          dispatch(
            navigateAction({
              to: editRoute,
              navigate,
            })
          );
          onClose();
        },
      }}
      secondaryBtnProps={{
        label: getTextContent('secondaryAction'),
        onClick: () => {
          closeModal();
          onClose();
        },
      }}
    >
      <Typography>{getTextContent('description')}</Typography>
    </Modal>
  );
};

export default EditModal;
